import { useHistory } from 'react-router-dom';

function DependencyGroup(props) {
	// Alternate background color based on row index
	var index = props.index;
	var dependencyGroup = props.dependencyGroup;
	var onEditClick = props.onEditClick;
	const bg = index % 2 === 0 ? "bg-[rgba(49,169,255,0.2)]" : "bg-[rgba(101,191,255,0.5)]";
	let history = useHistory();

	return (
		<div
			key={"dependencyGroup" + index}
			className={`relative h-[35px] w-full shrink-0`}
		>
			<button
				className={`${bg} cursor-pointer h-full w-full pr-12`}
				onClick={() => {
					history.push({
						pathname: "/Validator/" + dependencyGroup.name,
						dependencyGroup: dependencyGroup,
					});
				}}
			>
				<div
					aria-hidden="true"
					className="absolute inset-0 border border-[rgba(0,0,0,0.7)] pointer-events-none"
				/>
				<div className="flex h-full flex-row items-center">
					<div className="box-border flex h-[35px] w-full items-center px-[10px] py-[6px] font-['Inter:Medium',sans-serif] text-[16px] font-medium tracking-[-0.08px]">
						<div className="basis-0 grow">
							<p className="truncate leading-[1.45] text-left">
								{dependencyGroup.name}
							</p>
						</div>

						<div className="basis-0 grow">
							<p className="truncate leading-[1.45] text-left">
								{dependencyGroup.dependants.length}
							</p>
						</div>

						<div className="basis-0 grow">
							<p className="truncate leading-[1.45] text-left">
								{dependencyGroup.dependants.map(d => d.name).join(", ")}
							</p>
						</div>
					</div>
				</div>
			</button>

			<button
				className="absolute right-2 top-1/2 -translate-y-1/2 rounded border border-black bg-blue-500 px-2 py-1 text-sm text-white"
				onClick={onEditClick}
			>
				✏️
			</button>
		</div>
	);
} export default DependencyGroup